import { usePlugin } from "@/plugins";
import { UserProfileDto } from "./types";

const rawMenu = [
  {
    label: "เมนูหลัก",
    icon: "pi pi-fw pi-sliders-h",
    to: "/menu",
  },
  {
    label: "งานทั้งหมด",
    icon: "pi pi-fw pi-book",
    to: "/",
  },
  {
    label: "เอกสารอบรมต้นสังกัด",
    icon: "pi pi-fw pi-users",
    to: "/onthejob/list",
  },
  {
    label: "แจ้งปัญหาการใช้งาน",
    icon: "pi pi-fw pi-comment",
    command: () => {
      window.open(
        "https://itservice.haadthip.com/projects/hrdsmart/issues/new",
        "blank"
      );
    },
  },
];

const getMenu = (profile: UserProfileDto) => {
  let result = rawMenu;
  if (profile.isAdmin !== true) {
    result = result.filter((x) => x.label !== "เมนูหลัก");

    if (profile.isOnTheJobAdmin !== true) {
      result = result.filter((x) => x.label !== "เอกสารอบรมต้นสังกัด");
    }
  } else {
    result = result.filter((x) => x.label !== "เอกสารอบรมต้นสังกัด");
  }

  return result;
};

export default getMenu;
